/**
 * Function that generates the popover record when user clicks on a coach's tile in the report
 *
 * @param {object} params - Parameters
 * @param {function} params.showRecordPopover - A callback to show popover
 * @param {function} params.recordsShowPopover - A callback to show popover
 * @param {function} params.recordsShowRecord - A callback to show record
 * @param {function} params.onOrderPress - A callback to show order record
 *
 * @returns {function} - Callback - A function to be called when item is pressed
 */
import {ReportProps} from '../Report.types';

export function generateOnRecordPress({
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
  onOrderPress = () => {},
}: ReportProps) {
  return ({id}: any) =>
    showRecordPopover([id], {
      recordsShowPopover,
      recordsShowRecord,
      onOrderPress,
    });
}
